import { defaultHttpClient } from '../../httpClient';

export interface GoodsOptionsPricingOption {
  sno: number;
  count: number;
}

export interface GoodsOptionsPricingRequest {
  options: GoodsOptionsPricingOption[];
  fixed_coupon_sno?: number;
}

export interface GoodsOptionsPricingCouponItem {
  is_issued: boolean;
  discount_price: number;
  sno: number;
  applicable_type: number;
  issuer_type: number;
}

export interface GoodsOptionsPricingCoupon {
  logging: {
    analytics: object;
  };
  item: GoodsOptionsPricingCouponItem;
}

export interface GoodsOptionsPricingResponse {
  payback_amount: number;
  coupon: GoodsOptionsPricingCoupon | null;
  coupon_list: GoodsOptionsPricingCoupon[];
  discount_amount: number;
}

export const postGoodsOptionsPricing = (
  goodsSno: number,
  body: GoodsOptionsPricingRequest,
) => {
  return defaultHttpClient
    .request<GoodsOptionsPricingResponse>({
      method: 'POST',
      url: `/api/v2/goods/${goodsSno}/options/pricing/`,
      data: body,
    })
    .then(result => result.data);
};
